import React from 'react';
export function PainAgitationSection() {
  return <section className="w-full py-20 px-4 bg-navy-dark bg-grain" data-id="element-123">
      <div className="max-w-[680px] mx-auto flex flex-col space-y-8 text-lg md:text-xl leading-relaxed font-light text-cream" data-id="element-124">
        <p data-id="element-125">You're not unlucky. You're intercepted.</p>

        <p data-id="element-126">
          There's a specific moment most women recognize immediately — the
          moment you realize that no matter how hard you try, how positive you
          stay, or how much you pray... something keeps getting in the way.
        </p>

        <p data-id="element-127">
          It's not one big catastrophe. It's a pattern. A series of small
          collapses that add up to one exhausting feeling:
        </p>

        <p className="italic font-serif text-xl md:text-2xl text-cream/90" data-id="element-128">
          Why does it always go wrong for me?
        </p>

        <div className="w-full flex justify-end py-4" data-id="element-129">
          <p className="text-right italic font-serif text-2xl md:text-3xl text-rose max-w-[85%] leading-snug" data-id="element-130">
            "You work hard. You stay hopeful. And yet — the door closes. Again."
          </p>
        </div>

        <p data-id="element-131">
          Maybe it's a relationship that was almost perfect until it wasn't. A
          financial opportunity that fell through at the last minute. A
          friendship that turned cold for no reason. A body that started showing
          the stress you've been carrying for years.
        </p>

        <p data-id="element-132">
          You've tried to shake it off. You've bought the crystals. Said the
          affirmations. Lit the candles. And for a moment, it feels like things
          are shifting... until they don't.
        </p>

        <p data-id="element-133">What if the problem isn't your effort — or your faith?</p>

        <p data-id="element-134">
          What if there's a layer of interference that none of those things can
          reach?
        </p>

        <div className="w-full flex justify-start py-4" data-id="element-135">
          <p className="text-left italic font-serif text-2xl md:text-3xl text-gold max-w-[85%] leading-snug" data-id="element-136">
            "The static is real. And it has a frequency. Which means it can be
            cleared."
          </p>
        </div>
      </div>
    </section>;
}